/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { Step2DataOrgSize } from './step2DataOrgSize';

export interface Step2Data {
  /** @maxLength 255 */
  org_name: string;
  org_website?: string | null;
  org_size?: Step2DataOrgSize;
  org_logo_url?: string | null;
}
